export const QrDocType = Object.freeze({
  ALL: 'ALL' as string,
  WIRING: 'WIRING' as string,
  KEYPAD_COMPOSITION: 'KEYPAD_COMPOSITION' as string,
  PARAMETER_GROUP_COMPOSITION: 'PARAMETER_GROUP_COMPOSITION' as string,
  PARAMETER_SETTING: 'PARAMETER_SETTING' as string,
  KEYPAD_SIMULATION: 'KEYPAD_SIMULATION' as string,
  SPECIFICATIONS: 'SPECIFICATIONS' as string,
  OPTION_LIST: 'OPTION_LIST' as string,
  OPERATION_MANUAL: 'OPERATION_MANUAL' as string,
  QR_EDUCATION_VIDEO: 'QR_EDUCATION_VIDEO' as string,
  MANUAL_DOWNLOAD: 'MANUAL_DOWNLOAD' as string,
  // QUICK_GUIDE: 'QUICK_GUIDE' as string,
  FAULT_TRIPS_OCCURS: 'FAULT_TRIPS_OCCURS' as string,
  AFTER_A_TEST_RUN: 'AFTER_A_TEST_RUN' as string,
  MAINTENANCE: 'MAINTENANCE' as string,
  FAULT_TRIPS: 'FAULT_TRIPS' as string,
  OTHER_FAULTS: 'OTHER_FAULTS' as string,
  TRIP: 'TRIP' as string,
  TRIPS_AND_WARNING: 'TRIPS_AND_WARNING' as string,

  //QR 매뉴얼 게시글 등록할 때 게시판 드롭다운 보여주기를 위한 상수
  PARAMETER: 'PARAMETER' as string,
  TROUBLESHOOTING: 'TROUBLESHOOTING' as string,
});

export type QR_DOC_TYPE = keyof typeof QrDocType;

export const getQrDocTypeLangKey = (value: string) => {
  if (value === QrDocType.ALL) return 'I18N_QR_MANUAL_ALL';
  if (value === QrDocType.WIRING) return 'I18N_QR_MANUAL_WIRING';
  if (value == QrDocType.PARAMETER) return 'I18N_QR_MANUAL_PARAMETER';
  if (value === QrDocType.KEYPAD_COMPOSITION) return 'I18N_QR_MANUAL_KEYPAD_COMPOSITION';
  if (value === QrDocType.PARAMETER_GROUP_COMPOSITION) return 'I18N_QR_MANUAL_PARAMETER_GROUP_COMPOSITION';
  if (value === QrDocType.PARAMETER_SETTING) return 'I18N_QR_MANUAL_PARAMETER_SETTING';
  if (value === QrDocType.KEYPAD_SIMULATION) return 'I18N_QR_MANUAL_KEYPAD_SIMULATION';
  if (value === QrDocType.SPECIFICATIONS) return 'I18N_QR_MANUAL_SPECIFICATIONS';
  if (value === QrDocType.OPTION_LIST) return 'I18N_QR_MANUAL_OPTION_LIST';
  if (value === QrDocType.OPERATION_MANUAL) return 'I18N_QR_MANUAL_OPERATION_MANUAL';
  if (value === QrDocType.QR_EDUCATION_VIDEO) return 'I18N_QR_MANUAL_QR_EDUCATION_VIDEO';
  if (value === QrDocType.MANUAL_DOWNLOAD) return 'I18N_QR_MANUAL_MANUAL_DOWNLOAD';
  // if (value === DocType.QUICK_GUIDE) return 'I18N_QR_MANUAL_QUICK_GUIDE';
  if (value === QrDocType.TROUBLESHOOTING) return 'I18N_QR_MANUAL_TROUBLESHOOTING';
  if (value === QrDocType.FAULT_TRIPS_OCCURS) return 'I18N_QR_MANUAL_FAULT_TRIPS_OCCURS';
  if (value === QrDocType.AFTER_A_TEST_RUN) return 'I18N_QR_MANUAL_AFTER_A_TEST_RUN';
  if (value === QrDocType.MAINTENANCE) return 'I18N_QR_MANUAL_MAINTENANCE';
  if (value === QrDocType.FAULT_TRIPS) return 'I18N_QR_MANUAL_FAULT_TRIPS';
  if (value === QrDocType.OTHER_FAULTS) return 'I18N_QR_MANUAL_OTHER_FAULTS';
  if (value === QrDocType.TRIP) return 'I18N_QR_MANUAL_TRIP';
  if (value === QrDocType.TRIPS_AND_WARNING) return 'I18N_QR_MANUAL_TRIPS_AND_WARNING';

  return '';
};
